import _ from "lodash";

const mutationList = [
  { type: "Genetic", key: "ASXL1" },
  // { type: 'Genetic', key: 'ASXL2' },
  // { type: 'Genetic', key: 'ASXL3' },
  // { type: 'Genetic', key: 'ATRX' },
  // { type: 'Genetic', key: 'BAGE3' },
  { type: "Genetic", key: "BCOR" },
  // { type: 'Genetic', key: 'BRAF' },
  // { type: 'Genetic', key: 'CBFB' },
  // { type: 'Genetic', key: 'CBL' },
  // { type: 'Genetic', key: 'CDKN2A' },
  { type: "Genetic", key: "CEBPA_bi" },
  { type: "Genetic", key: "CEBPA_mono" },
  // { type: 'Genetic', key: 'CNTN5' },
  // { type: 'Genetic', key: 'CREBBP' },
  // { type: 'Genetic', key: 'CSF1R' },
  // { type: 'Genetic', key: 'CSF3R' },
  // { type: 'Genetic', key: 'CTCF' },
  // { type: 'Genetic', key: 'CUL2' },
  { type: "Genetic", key: "CUX1" },
  { type: "Genetic", key: "DNMT3A" },
  // { type: 'Genetic', key: 'EED' },
  // { type: 'Genetic', key: 'ETV6' },
  { type: "Genetic", key: "EZH2" },
  // { type: 'Genetic', key: 'FBXW7' },
  { type: "Genetic", key: "ITD", text: "FLT3-ITD" },
  { type: "Genetic", key: "FLT3_TKD" },
  { type: "Genetic", key: "FLT3_other" },
  // { type: 'Genetic', key: 'GATA1' },
  { type: "Genetic", key: "GATA2" },
  // { type: 'Genetic', key: 'GNAS' },
  // { type: 'Genetic', key: 'GNB1' },
  { type: "Genetic", key: "IDH1" },
  { type: "Genetic", key: "IDH2_p.R140" },
  { type: "Genetic", key: "IDH2_p.R172" },
  // { type: 'Genetic', key: 'JAK2' },
  // { type: 'Genetic', key: 'JAK3' },
  // { type: 'Genetic', key: 'KANSL1' },
  // { type: 'Genetic', key: 'KDM6A' },
  { type: "Genetic", key: "KIT" },
  // { type: 'Genetic', key: 'KMT2C' },
  // { type: 'Genetic', key: 'KMT2D' },
  // { type: 'Genetic', key: 'KMT2E' },
  { type: "Genetic", key: "KRAS" },
  // { type: 'Genetic', key: 'LUC7L2' },
  // { type: 'Genetic', key: 'MED12' },
  { type: "Genetic", key: "MLL" },
  { type: "Genetic", key: "MPL" },
  { type: "Genetic", key: "MYC" },
  { type: "Genetic", key: "NF1" },
  // { type: 'Genetic', key: 'NFE2' },
  // { type: 'Genetic', key: 'NOTCH1' },
  { type: "Genetic", key: "NPM1" },
  { type: "Genetic", key: "NRAS_other" },
  { type: "Genetic", key: "NRAS_p.G12_13" },
  { type: "Genetic", key: "NRAS_p.Q61_62" },
  // { type: 'Genetic', key: 'PDS5B' },
  { type: "Genetic", key: "PHF6" },
  // { type: 'Genetic', key: 'PPFIA2' },
  // { type: 'Genetic', key: 'PRPF8' },
  // { type: 'Genetic', key: 'PTEN' },
  { type: "Genetic", key: "PTPN11" },
  // { type: 'Genetic', key: 'PTPRF' },
  // { type: 'Genetic', key: 'PTPRT' },
  // { type: 'Genetic', key: 'RAD21' },
  // { type: 'Genetic', key: 'RIT1' },
  { type: "Genetic", key: "RUNX1" },
  // { type: 'Genetic', key: 'S100B' },
  { type: "Genetic", key: "SETBP1" },
  { type: "Genetic", key: "SF1" },
  { type: "Genetic", key: "SF3B1" },
  // { type: 'Genetic', key: 'SMC1A' },
  { type: "Genetic", key: "SMC3" },
  // { type: 'Genetic', key: 'SMG1' },
  // { type: 'Genetic', key: 'SPP1' },
  { type: "Genetic", key: "SRSF2" },
  { type: "Genetic", key: "STAG2" },
  // { type: 'Genetic', key: 'STAT5B' },
  // { type: 'Genetic', key: 'SUZ12' },
  { type: "Genetic", key: "TET2" },
  { type: "Genetic", key: "TP53" },
  { type: "Genetic", key: "U2AF1_p.S34" },
  { type: "Genetic", key: "U2AF1_p.Q157" },
  { type: "Genetic", key: "WT1" },
  { type: "Genetic", key: "ZRSR2" },
  { type: "CNA", key: "complex", text: "Complex: 3 or more aneuploidies." },
  { type: "CNA", key: "add_1", text: "add(1)" },
  { type: "CNA", key: "add_2", text: "add(2)" },
  { type: "CNA", key: "add_3", text: "add(3)" },
  { type: "CNA", key: "add_4", text: "add(4)" },
  { type: "CNA", key: "add_5", text: "add(5)" },
  { type: "CNA", key: "add_6", text: "add(6)" },
  { type: "CNA", key: "add_7", text: "add(7)" },
  { type: "CNA", key: "add_8", text: "add(8)" },
  { type: "CNA", key: "add_9", text: "add(9)" },
  { type: "CNA", key: "add_10", text: "add(10)" },
  { type: "CNA", key: "add_11", text: "add(11)" },
  { type: "CNA", key: "add_12", text: "add(12)" },
  { type: "CNA", key: "add_13", text: "add(13)" },
  { type: "CNA", key: "add_14", text: "add(14)" },
  { type: "CNA", key: "add_15", text: "add(15)" },
  { type: "CNA", key: "add_16", text: "add(16)" },
  { type: "CNA", key: "add_17", text: "add(17)" },
  { type: "CNA", key: "add_18", text: "add(18)" },
  { type: "CNA", key: "add_19", text: "add(19)" },
  { type: "CNA", key: "add_20", text: "add(20)" },
  { type: "CNA", key: "add_21", text: "add(21)" },
  { type: "CNA", key: "add_22", text: "add(22)" },
  { type: "CNA", key: "del_1", text: "del(1)" },
  { type: "CNA", key: "del_2", text: "del(2)" },
  { type: "CNA", key: "del_3", text: "del(3)" },
  { type: "CNA", key: "del_4", text: "del(4)" },
  { type: "CNA", key: "del_5", text: "del(5)" },
  { type: "CNA", key: "del_6", text: "del(6)" },
  { type: "CNA", key: "del_7", text: "del(7)" },
  { type: "CNA", key: "del_8", text: "del(8)" },
  { type: "CNA", key: "del_9", text: "del(9)" },
  { type: "CNA", key: "del_10", text: "del(10)" },
  { type: "CNA", key: "del_11", text: "del(11)" },
  { type: "CNA", key: "del_12", text: "del(12)" },
  { type: "CNA", key: "del_13", text: "del(13)" },
  { type: "CNA", key: "del_14", text: "del(14)" },
  { type: "CNA", key: "del_15", text: "del(15)" },
  { type: "CNA", key: "del_16", text: "del(16)" },
  { type: "CNA", key: "del_17", text: "del(17)" },
  { type: "CNA", key: "del_18", text: "del(18)" },
  { type: "CNA", key: "del_19", text: "del(19)" },
  { type: "CNA", key: "del_20", text: "del(20)" },
  { type: "CNA", key: "del_21", text: "del(21)" },
  { type: "CNA", key: "del_22", text: "del(22)" },
  { type: "CNA", key: "minusy", text: "Minus chrY" },
  { type: "Fusions", key: "t_v_11", text: "t(v;11)" },
  { type: "Fusions", key: "t_10_21", text: "t(10;21)" },
  { type: "Fusions", key: "t_12_13", text: "t(12;13)" },
  { type: "Fusions", key: "t_12_17", text: "t(12;17)" },
  { type: "Fusions", key: "t_12_22", text: "t(12;22)" },
  { type: "Fusions", key: "t_13_19", text: "t(13;19)" },
  { type: "Fusions", key: "t_15_16", text: "t(15;16)" },
  { type: "Fusions", key: "t_15_17", text: "t(15;17)" },
  { type: "Fusions", key: "t_16_17", text: "t(16;17)" },
  { type: "Fusions", key: "t_16_21", text: "t(16;21)" },
  { type: "Fusions", key: "t_17_19", text: "t(17;19)" },
  { type: "Fusions", key: "t_17_21", text: "t(17;21)" },
  { type: "Fusions", key: "t_1_12", text: "t(1;12)" },
  { type: "Fusions", key: "t_1_14", text: "t(1;14)" },
  { type: "Fusions", key: "t_1_16", text: "t(1;16)" },
  { type: "Fusions", key: "t_1_17", text: "t(1;17)" },
  { type: "Fusions", key: "t_1_19", text: "t(1;19)" },
  { type: "Fusions", key: "t_1_3", text: "t(1;3)" },
  { type: "Fusions", key: "t_1_4", text: "t(1;4)" },
  { type: "Fusions", key: "t_1_5", text: "t(1;5)" },
  { type: "Fusions", key: "t_1_6", text: "t(1;6)" },
  { type: "Fusions", key: "t_2_17", text: "t(2;17)" },
  { type: "Fusions", key: "t_2_3", text: "t(2;3)" },
  { type: "Fusions", key: "t_2_5", text: "t(2;5)" },
  { type: "Fusions", key: "t_2_7", text: "t(2;7)" },
  { type: "Fusions", key: "t_2_9", text: "t(2;9)" },
  { type: "Fusions", key: "t_3_16", text: "t(3;16)" },
  { type: "Fusions", key: "t_3_21", text: "t(3;21)" },
  { type: "Fusions", key: "t_3_5", text: "t(3;5)" },
  { type: "Fusions", key: "t_3_7", text: "t(3;7)" },
  { type: "Fusions", key: "t_3_9", text: "t(3;9)" },
  { type: "Fusions", key: "t_4_12", text: "t(4;12)" },
  { type: "Fusions", key: "t_4_21", text: "t(4;21)" },
  { type: "Fusions", key: "t_4_9", text: "t(4;9)" },
  { type: "Fusions", key: "t_5_12", text: "t(5;12)" },
  { type: "Fusions", key: "t_5_17", text: "t(5;17)" },
  { type: "Fusions", key: "t_5_9", text: "t(5;9)" },
  { type: "Fusions", key: "t_6_9", text: "t(6;9)" },
  { type: "Fusions", key: "t_7_16", text: "t(7;16)" },
  { type: "Fusions", key: "t_7_17", text: "t(7;17)" },
  { type: "Fusions", key: "t_7_8", text: "t(7;8)" },
  { type: "Fusions", key: "t_8_10", text: "t(8;10)" },
  { type: "Fusions", key: "t_8_13", text: "t(8;13)" },
  { type: "Fusions", key: "t_8_16", text: "t(8;16)" },
  { type: "Fusions", key: "t_8_17", text: "t(8;17)" },
  { type: "Fusions", key: "t_8_21", text: "t(8;21)" },
  { type: "Fusions", key: "t_9_11", text: "t(9;11)" },
  { type: "Fusions", key: "t_9_13", text: "t(9;13)" },
  { type: "Fusions", key: "t_9_17", text: "t(9;17)" },
  { type: "Fusions", key: "t_9_22", text: "t(9;22)" },
  { type: "Fusions", key: "others_transloc", text: "Others Translocations" },
  { type: "Fusions", key: "inv_3", text: "inv(3)" },
  { type: "Fusions", key: "inv_16", text: "inv(16)" }
].map(i => {
  i.value = i.key;
  i.text = i.text || i.key;
  return i;
});

export { mutationList };
export default _.groupBy(mutationList, "type");
